import {
  AppBar,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Route, Routes } from 'react-router-dom';

const useStyles = makeStyles(() =>
  createStyles({
    eligibilityCheckerToolBar: {
      flexDirection: 'row',
    },
  }),
);
export const ELIGIBILITY_CHECKER_DATA_TEST_ID = 'eligibility-checker';

const WelcomeMessage = (): JSX.Element => (
  <HHStack alignItems="center" margin="1em" flex={1}>
    <HHTypography hhVariant="section-title">Eligibility</HHTypography>
  </HHStack>
);

const EligibilityHeader = (): JSX.Element => {
  const classes = useStyles();

  return (
    <AppBar
      elevation={3}
      variant="elevation"
      color="inherit"
      position="sticky"
      className={classes.eligibilityCheckerToolBar}
      data-testid={ELIGIBILITY_CHECKER_DATA_TEST_ID}
    >
      <Routes>
        <Route path="*" element={<WelcomeMessage />} />
      </Routes>
    </AppBar>
  );
};
export default EligibilityHeader;
